export const data_guest = [{
    currentMonth: 'N/A',
    currentMonthNo: 'N/A',
    totalNoOfReview: 'N/A',
    Cleanliness: 'N/A',
    Service: 'N/A',
    YTD: 'N/A',
    YTDNo: 'N/A'
}]


// WEBPACK FOOTER //
// ./src/components/table/guestRating/data.js